module.exports = __webpack_public_path__ + "img/containerRearLeft.0141a44a.svg";